export type ClerkKeyMode = 'test' | 'live';

export function getClerkKeyMode(value?: string | null): ClerkKeyMode | null {
  if (!value) return null;
  if (value.startsWith('pk_test_') || value.startsWith('sk_test_')) return 'test';
  if (value.startsWith('pk_live_') || value.startsWith('sk_live_')) return 'live';
  return null;
}

function isLocalHostname(hostname: string) {
  return hostname === 'localhost' || hostname === '127.0.0.1';
}

export function getClerkRuntimeProblem({
  publishableKey,
  hostname,
}: {
  publishableKey?: string | null;
  hostname: string;
}) {
  if (getClerkKeyMode(publishableKey) === 'live' && isLocalHostname(hostname)) {
    return {
      title: 'Clerk configuration required',
      message:
        'Production Clerk publishable keys can only run on theaibrandlab.com. Use a development Clerk key on localhost or test against the live domain.',
    };
  }

  return null;
}
